import React from 'react';
import { Card as MuiCard } from '@mui/material';
import { withStyles } from 'tss-react/mui';

export const Card = withStyles(MuiCard, (theme) => ({
  root: {
    boxShadow: '0px 12px 24px -4px rgba(204, 204, 204, 0.2), 0px 0px 2px 0px rgba(204, 204, 204, 0.4)',
  },
}));
